export default __webpack_public_path__ + "static/media/ovalsBlurred.c911e6b1.webp";